import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { LoadingSpinner } from '@/components/ui/loading-spinner'
import { DEV_FAKE_STAFF } from '@/config'
import { useSession } from '@/lib/auth-client'

/**
 * Layout route guarding the staff (private) part of the app.
 * Client-side redirect is UX only — real enforcement lives in the server's
 * staffProcedure (session or API token required).
 */
export function RequireStaffAuth() {
	const { data: session, isPending } = useSession()
	const location = useLocation()

	// Dev-only bypass; compiled out of production builds (see config.ts)
	if (DEV_FAKE_STAFF) {
		return <Outlet />
	}

	if (isPending) {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<LoadingSpinner size="lg" />
			</div>
		)
	}

	if (!session) {
		return <Navigate to="/login" state={{ from: location }} replace />
	}

	return <Outlet />
}
